<div class="layout-container">
  <app-sidebar></app-sidebar>

  <div class="main-content-wrapper">
    
    <app-header><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" /></app-header>
    
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
    
    <app-footer></app-footer>

  </div>
</div>